import { CLASS_CHECKBOX } from "../../helpers/classes";
import Input from "./Input";

interface MultiCheckboxOption {
    label: string;
    value: string;
}

interface MultiCheckboxProps {
    title?: string;
    name?: string;
    onChangeFunction: (value: string) => void;
    options?: (string | MultiCheckboxOption)[];
    className?: string;
    inputClassName?: string;
    titleClassname?: string;
    editing?: boolean;
    textBoxClass?: string;
    value: string;
    isDisabled?: boolean;
    children?: any;
    optionsInColumns?: boolean;
}

export const MultiCheckbox = ({
    title,
    onChangeFunction,
    options,
    className,
    inputClassName,
    titleClassname,
    editing,
    value,
    isDisabled,
    children,
    optionsInColumns = false,
}: MultiCheckboxProps) => {
    return (
        <div className={`flex flex-col ${className}`}>
            {title && (
                <div className={`text-r-medium-small-2 ${titleClassname ?? ""}`}>{title}</div>
            )}
            <div className={`flex ${optionsInColumns ? "flex-col" : "flex-row"} gap-2 flex-wrap`}>
                {options?.map((o) => {
                    const opt = typeof o === "string" ? { label: o, value: o } : o;

                    return (
                        <Input
                            isDisabled={isDisabled}
                            editing={editing}
                            key={opt.value}
                            type="checkbox"
                            className="md:col-span-5 lg:col-span-0 flex flex-row gap-0 md:gap-2 lg:gap-0 items-center mb-1 md:mb-0"
                            inputClassName={`${CLASS_CHECKBOX} ${inputClassName}`}
                            checkboxNotClickable={false}
                            isChecked={value === opt.value}
                            name={opt.value}
                            checkboxTitle={opt.label}
                            value={opt.value}
                            onChangeFunction={(val: string) => {
                                let newValue = value.split(",");
                                if (newValue?.includes(val)) {
                                    newValue = newValue.filter((v) => v !== val && v);
                                } else {
                                    newValue.push(val);
                                }
                                onChangeFunction(newValue.join(","));
                            }}
                        />
                    );
                })}
            </div>

            {/* You can pass a component to display stuff under the input. Its usually used for
            displaying error msges */}
            {children && children}
        </div>
    );
};
